import React from 'react';
import { gettext } from '@eventbrite/i18n';
import { Icon } from '@eventbrite/eds-icon';
import './SubscriptionTools.scss';
import { ICON_SVG } from './PricingPageIcons';
import { Typography, Divider, Button } from '@eventbrite/marmalade';

import {
    Clipboard,
    HandWithMoney,
    Megaphone,
    Ticket,
    Trending,
} from '@eventbrite/eds-iconography';

const SUBSCRIPTION_TOOLS = [
    {
        icon: ICON_SVG.ticket,
        headerText: gettext('Easy ticketing'),
        listItems: [
            gettext('Custom event pages'),
            gettext('Multiple ticket types'),
            gettext('Custom registration forms'),
            gettext('AI-powered content tools'),
            gettext('Sell add-ons'),
        ],
    },
    {
        icon: ICON_SVG.megaphone,
        headerText: gettext('Marketing tools'),
        listItems: [
            gettext('Email marketing'),
            gettext('Facebook and Instragram ads'),
            gettext('Eventbrite Ads'),
            gettext('Promo codes'),
            gettext('Organizer profile'),
        ],
    },
    {
        icon: ICON_SVG.card_in_hand,
        headerText: gettext('Secure payments'),
        listItems: [
            gettext('Built-in payment processing'),
            gettext('Pre-event payouts'),
            gettext('Embedded checkout on your own website'),
            gettext('Custom refund policy'),
        ],
    },
    {
        icon: ICON_SVG.trending,
        headerText: gettext('Data insights'),
        listItems: [
            gettext('Sales dashboards'),
            gettext('Traffic and conversion reporting'),
            gettext('Smart audiences'),
            gettext('Ad budget optimization'),
        ],
    },
    {
        icon: ICON_SVG.clipboard,
        headerText: gettext('Event management'),
        listItems: [
            gettext('On-site check in with Organizer app'),
            gettext('Waitlists'),
            gettext('Team permissions'),
            gettext('3rd party integrations'),
            gettext('Courses & video tutorials'),
        ],
    },
];

export const SubscriptionTool = ({ icon, headerText, listItems }) => {
    return (
        <div className="pricing-and-packaging-subscription-tool">
            <div className="tool-icon">{icon}</div>
            <div className="tool-info">
                <Typography as="h2" color="#1E0A3C" variant="body-lg">
                    {headerText}
                </Typography>
                <ul className="tool-list">
                    {listItems.map((text, i) => (
                        <li key={i}>
                            <Typography
                                as="p"
                                color="#1E0A3C"
                                variant="body-md"
                            >
                                {`${text}`}
                            </Typography>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export const SubscriptionTools = () => {
    return (
        <div className="subscription-tools-block">
            <h2 className="subscription-tools-header">
                <Typography as="h6" color="#1E0A3C" variant="display-sm">
                    {gettext('INCLUDED IN EVERY PLAN')}
                </Typography>
            </h2>
            <Divider
                style={{
                    width: '127px',
                    height: '2px',
                    background: '#DDDAE3',
                }}
            />
            <div className="pricing-and-packaging-tools">
                {SUBSCRIPTION_TOOLS.map((toolProps, i) => (
                    <SubscriptionTool key={i} {...toolProps} />
                ))}
            </div>
            <div className="subscription-tools-block-button">
                <Button
                    onClick={() => {
                        window.location.href = '/organizer/compare-packages/';
                    }}
                    variant="secondary"
                >
                    <Typography
                        as="span"
                        color="neutral-900"
                        variant="body-md-bold"
                    >
                        {gettext('View all features and compare plans')}
                    </Typography>
                </Button>
            </div>
        </div>
    );
};

export default SubscriptionTools;
